<template>
  <section class="articles container mb-5">
    <!-- <HeaderSection
      v-if="blogs && blogs.length"
      :textBtn="'مطالب بیشتر'"
      :status="status"
      :text="'پست ها'"
      :route="'/weblog-list'"
    /> -->
    <div v-if="blogs && blogs.length" class="title-box d-flex align-items-center justify-content-between">
      <h3 class="font-weight-bold fontsize-xheavy">
        پست ها
      </h3>
      <router-link :to="`/weblog-list`" class="text-dark font-weight-bold ">مطالب بیشتر</router-link>
    </div>
    <b-row v-if="status">
      <b-col>
        <b-skeleton-img></b-skeleton-img> <br />
        <b-skeleton></b-skeleton>
      </b-col>
      <b-col>
        <b-skeleton-img></b-skeleton-img><br />
        <b-skeleton></b-skeleton>
      </b-col>
      <b-col>
        <b-skeleton-img></b-skeleton-img><br />
        <b-skeleton></b-skeleton>
      </b-col>
      <b-col>
        <b-skeleton-img></b-skeleton-img><br />
        <b-skeleton></b-skeleton>
      </b-col>
    </b-row>
    <div id="blogArticleContent" v-else class="articles-content">
      <!-- دریافت اطلاعات از آبجکت هوم و وارد شدن به آبجکت پست -->
      <template v-if="blogs != null">
        <article v-for="(blog, index) in blogs.slice(0, 4)" :key="'Blog' + index" class="BlogCArd">
          <router-link :to="{
      name: 'blogDetail',
      params: { id: blog.id },
      query: { slug: blog.slug },
    }">
            <figure class="article-img">
              <img loading="lazy" v-if="blog.image" :src="blog.image.url" :alt="blog.title" />
              <img loading="lazy" v-else src="../../../assets/images/blog.jpg" alt="blog" />

            </figure>
            <div v-if="blog.created_at" class="date-created-at">
              <!-- <span>تاریخ انتشار:</span> -->
              <time :datetime="blog.created_at"> {{ moment(blog.created_at).format("YYYY/MM/DD") }}</time>
            </div>
            <div class="text-right article-title">
              <!-- <div class="blogCategory">
                <span>دسته بندی:</span>
                <router-link
                  :to="`/weblog-list/${blog.category.id}/${blog.category.slug}`"
                >
                  {{ blog.category.name }}
                </router-link>
              </div> -->
              <h6 class="d-inline-block fontsize-small weight-bold text-color-444 ">
                <!-- <svg
                  class="mt-n1"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.36922 10.869C7.42572 10.811 7.63906 10.563 7.8378 10.359C9.00292 9.076 12.0424 6.976 13.6332 6.335C13.8748 6.232 14.4856 6.014 14.812 6C15.1247 6 15.4228 6.072 15.7073 6.218C16.0619 6.422 16.3463 6.743 16.5022 7.122C16.6025 7.385 16.7584 8.172 16.7584 8.186C16.9143 9.047 17 10.446 17 11.992C17 13.465 16.9143 14.807 16.7867 15.681C16.772 15.695 16.6162 16.673 16.4457 17.008C16.133 17.62 15.5222 18 14.8685 18H14.812C14.3863 17.985 13.491 17.605 13.491 17.591C11.9859 16.949 9.01656 14.952 7.82319 13.625C7.82319 13.625 7.48709 13.284 7.34096 13.071C7.11301 12.765 7 12.386 7 12.007C7 11.584 7.12762 11.19 7.36922 10.869Z"
                    fill="#444"
                  />
                </svg> -->
                {{ blog.title }}
              </h6>
              <!-- <p class="blogSummary">
                {{
                  blog.summary
                    ? blog.summary.length > 150
                      ? blog.summary.slice(0, 150) + "..."
                      : blog.summary
                    : ""
                }}
              </p> -->

            </div>
          </router-link>
        </article>
      </template>
    </div>
  </section>
</template>

<script>
import HeaderSection from "@/parts/Front/components/HeaderSection";
import { BSkeleton, BSkeletonImg, BRow, BCol } from "bootstrap-vue";

export default {
  components: {
    HeaderSection,
    BSkeleton,
    BSkeletonImg,
    BRow,
    BCol,
  },
  name: "Weblogs",
  mounted() {
    if (!this.blogs) {
      this.$store.dispatch("front/getAllBlogFromServer", {});
    }
    // get height of articles/
    let bodyWidth = document.body.offsetWidth;
    const articleImg = document.querySelectorAll(".article-img");
    if (bodyWidth < 767) {
      for (let iImg of articleImg) {
        let imgH = iImg.offsetWidth / 1.45;
        iImg.style.height = imgH + "px";
      }
    }

    window.addEventListener("resize", function () {
      // get height of articles/
      // let bodyWidth=document.body.offsetWidth;
      const articleImg = document.querySelectorAll(".article-img");
      for (let iImg of articleImg) {
        let imgH = iImg.offsetWidth / 1.45;
        iImg.style.height = imgH + "px";
      }
    });
  },

  computed: {
    blogs() {//دریافت اطلاعات برای قسمت بلاگ که در تمپلیت بالا وارد آبجکت پست از این آبجکت میشود
      //دریافت اطلاعات برای قسمت بلاگ که در تمپلیت بالا وارد آبجکت پست از این آبجکت میشود
      return this.$store.getters["front/getHomeBlogs"];
    },
    status() {
      ///نمایش لودینگ ها به کمک استاتوس
      return this.$store.getters["front/getHomeDataStatus"];
    },
  },
};
</script>

<style>
.blogCategory a {
  color: gray;
  padding: .15rem .925rem;
  background-color: rgb(210 239 154);
  font-size: 14px;
  border-radius: 50px;
}

.blogCategory {
  margin: 8px auto;
  color: black;
  display: flex;
  gap: 8px;

}

p.blogSummary,
.date-created-at {
  color: #00000080;
  font-size: 14px;
  margin-bottom: 8px;
  padding-right: 8px;
}

.BlogCArd {

  /* box-shadow: 0 0 4px #1213;*/
  /* padding: 2px;*/
}

.article-img {
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 8px;
}

.article-img img {
  border-radius: 16px;
  transition: all .5s;
}

.BlogCArd:hover .article-img img {
  transform: scale(1.2);
}
</style>
<style scoped>
.articles {
  margin-top: 60px !important;
}

.title-box {
  margin-bottom: 2rem;

  border-bottom: 0.0625rem solid #dadee4;
}

.title-box a {
  display: inline-block;
  width: fit-content;
  font-size: 15px;
  padding: 0 4px;
}

@media screen and (max-width: 500px) {

  .title-box h3 {
    font-size: 18px !important;
  }

  .title-box a {
    font-size: 13px;
  }

  .home-products-Slder {
    margin-top: 40px !important;
  }
}
</style>
